module.exports = __webpack_public_path__ + "img/arrow_ver.fdb2b32d.svg";